const ViewValueHypothesisKPIsBy = {
  VALUE: "value",
  IMPORTANCE: "importance"
} as const;

const ALL = Object.values(ViewValueHypothesisKPIsBy);

export default { ...ViewValueHypothesisKPIsBy, ALL };
